import Api from '@sendsprint/api-types';
// import { submitBusinessDetailsService, UpdateBusinessLocationService } from '@src/services';
import { DURATION_1_HR } from '@src/constants';
import {
  submitBusinessDetailsService,
  submitBusinessInformationService,
  submitBusinessAddressService,
  submitBusinessDocumentsService,
  getBusinessInformationCompletionCheckService,
  submitBusinessActivationService,
  UpdateBusinessLocationService,
  getBusinessInformationDetailsService
} from '@src/services';
import ClientApi from '@src/types/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';

export const useSubmitBusinessDetails = (
  options?: Omit<
    UseMutationOptions<
      boolean,
      AxiosError<Api.Endpoint.Response.ErrorResponse>,
      ClientApi.Onboarding.SubmitBusinessDetails.Request
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    boolean,
    AxiosError<Api.Endpoint.Response.ErrorResponse>,
    ClientApi.Onboarding.SubmitBusinessDetails.Request
  >('submitBusinessDetails', submitBusinessDetailsService, options);
};

export const useSubmitBusinessDocuments = (
  options?: Omit<
    UseMutationOptions<
      boolean,
      AxiosError<Api.Endpoint.Response.ErrorResponse>,
      ClientApi.Onboarding.SubmitBusinessDocuments.Request
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    boolean,
    AxiosError<Api.Endpoint.Response.ErrorResponse>,
    ClientApi.Onboarding.SubmitBusinessDocuments.Request
  >('submitBusinessDocuments', submitBusinessDocumentsService, options);
};

export const useUpdateBusinessLocation = (
  options?: Omit<
    UseMutationOptions<
      ClientApi.Onboarding.UpdateBusinessLocation.Response['data'],
      AxiosError<Api.Endpoint.Response.ErrorResponse>,
      ClientApi.Onboarding.UpdateBusinessLocation.Request
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    ClientApi.Onboarding.UpdateBusinessLocation.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>,
    ClientApi.Onboarding.UpdateBusinessLocation.Request
  >('updateBusinessLocation', UpdateBusinessLocationService, options);
};

export const useSubmitBusinessInformation = (
  options?: Omit<
    UseMutationOptions<
      ClientApi.Onboarding.SubmitBusinessInformation.Response['data'],
      AxiosError<Api.Endpoint.Response.ErrorResponse>,
      ClientApi.Onboarding.SubmitBusinessInformation.Request
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    ClientApi.Onboarding.SubmitBusinessInformation.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>,
    ClientApi.Onboarding.SubmitBusinessInformation.Request
  >('submitBusinessInformation', submitBusinessInformationService, options);
};

export const useSubmitBusinessAddress = (
  options?: Omit<
    UseMutationOptions<
      boolean,
      AxiosError<Api.Endpoint.Response.ErrorResponse>,
      ClientApi.Onboarding.SubmitBusinessAddress.Request
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    boolean,
    AxiosError<Api.Endpoint.Response.ErrorResponse>,
    ClientApi.Onboarding.SubmitBusinessAddress.Request
  >('submitBusinessAddress', submitBusinessAddressService, options);
};

export const useGetBusinessInformationCompletionCheck = (
  options?: UseQueryOptions<
    ClientApi.Onboarding.GetBusinessInformationCompletionCheck.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>
  >
) => {
  return useQuery<
    ClientApi.Onboarding.GetBusinessInformationCompletionCheck.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>
  >({
    queryKey: ['getBusinessInformationCompletionCheck'],
    queryFn: () => getBusinessInformationCompletionCheckService(),
    staleTime: DURATION_1_HR,
    ...options
  });
};

export const useGetBusinessInformationDetails = (
  options?: UseQueryOptions<
    ClientApi.Onboarding.GetBusinessInformationDetails.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>
  >
) => {
  return useQuery<
    ClientApi.Onboarding.GetBusinessInformationDetails.Response['data'],
    AxiosError<Api.Endpoint.Response.ErrorResponse>
  >({
    queryKey: ['getBusinessInformationDetails'],
    queryFn: () => getBusinessInformationDetailsService(),
    staleTime: DURATION_1_HR,
    ...options
  });
};

export const useSubmitBusinessActivation = (
  options?: Omit<
    UseMutationOptions<boolean, AxiosError<Api.Endpoint.Response.ErrorResponse>>,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<boolean, AxiosError<Api.Endpoint.Response.ErrorResponse>>(
    'submitBusinessActivation',
    submitBusinessActivationService,
    options
  );
};
